import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import { ItemsCarousel } from './ItemsCarousel';
import * as styles from './NewbuildingRecommendations.css';

type TNewbuildingRecommendationsProps = {
  renderItems(): React.ReactNode;
};

export const NewbuildingRecommendations: React.FC<TNewbuildingRecommendationsProps> = ({ renderItems }) => {
  return (
    <section
      data-testid="NewbuildingRecommendations"
      data-name="NewbuildingRecommendations"
      className={styles['section']}
    >
      <div className={styles['header']}>
        <UIHeading2 as="h2">Популярные жилые комплексы от застройщиков</UIHeading2>
      </div>
      <div className={styles['carousel-wrapper']}>
        <ItemsCarousel blurArrowOnPointerClick scrollVisible styles={styles['carousel']} renderOutside={renderItems} />
      </div>
    </section>
  );
};
